import FinanceSerializer from './base';

export default class InternalOrder extends FinanceSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      isActive: false,
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);
    return super.normalize(...arguments);
  }
}
